query CartProgressQuery($site: [String!]) {
  globalSet(site: $site, handle: "cartSettings") {
    handle
    ... on cartSettings_GlobalSet {
      freeShippingThreshold
    }
  }
}
